import React from "react"

import CheckoutFlowNavButtons from "~components/pages/listing/checkout/checkout-flow/checkout-flow-nav-buttons"
import DateSelect from "~components/pages/listing/checkout/date-select"
import { useCheckoutFlow } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-provider"
import { areDatesValid } from "~components/pages/listing/checkout/checkout-flow/checkout-flow-helpers"
import { isSetDayPricingPackage } from "~utils/helpers"
import { getListingType } from "~utils/listing-helpers"

import CheckoutFlowStep from "./checkout-flow-step"

export default function CheckoutFlowDatesStep() {
    const {
        dates,
        setDates,
        currentMonth,
        setCurrentMonth,
        editableFields,
        listing,
        availableDates,
        pricingPackage,
        isWidget,
    } = useCheckoutFlow()

    // For typescript. There should always be a pricing package set
    // during the first flow when the dates step is included. Listing is
    // defaulted to null in the context, so also needs to be checked.
    if (!listing || !pricingPackage) return null

    const listingType = getListingType(listing)

    const isSetDay = isSetDayPricingPackage(pricingPackage)

    return (
        <CheckoutFlowStep
            renderNavButtons={() => (
                <CheckoutFlowNavButtons
                    isContinueDisabled={!areDatesValid(dates)}
                />
            )}
        >
            <DateSelect
                listingType={listingType}
                availableDates={availableDates}
                dates={dates}
                openToDate={currentMonth}
                onChange={setDates}
                onMonthChange={(date) => setCurrentMonth(date)}
                isDisabled={!editableFields.dates}
                isPricingPackageSetDay={isSetDay}
                daysIncludedInPackage={pricingPackage.days_included}
                isSingleMonth={isWidget}
            />
        </CheckoutFlowStep>
    )
}
